import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeMedium"><Path fillRule="evenodd" clipRule="evenodd" d="M8.41436 8.00015L4.41436 12.0002L8.41436 16.0001L7.00015 17.4144L1.58594 12.0002L7.00015 6.58594L8.41436 8.00015ZM17.0002 6.58594L22.4144 12.0002L17.0002 17.4144L15.5859 16.0001L19.5859 12.0002L15.5859 8.00015L17.0002 6.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeMedium;
